import { Coins, FileText, MapPinned, Rocket, BookOpen } from "lucide-react";

/**
 * Dati condivisi dei 5 articoli del blog.
 * Usati sia dalla pagina /blog (card) che dalle pagine /blog/:slug (dettaglio).
 */
export const ARTICLES = [
  {
    id: 1,
    slug: "nuova-sabatini",
    category: "Agevolazioni",
    date: "10 Maggio 2026",
    title: "Nuova Sabatini: contributi per macchinari, impianti e investimenti aziendali",
    excerpt:
      "Uno strumento pensato per supportare le imprese negli investimenti in beni strumentali e programmi di sviluppo aziendale.",
    icon: Coins,
    cover: "/blog-nuova-sabatini.jpg",
    sections: [
      {
        title: "Cos'è la Nuova Sabatini",
        paragraphs: [
          "La Nuova Sabatini è un'agevolazione che supporta le imprese negli investimenti in macchinari, impianti, attrezzature e tecnologie attraverso un contributo economico concesso a fronte di finanziamenti o leasing destinati all'acquisto di beni strumentali.",
          "Il beneficio consiste in un'agevolazione sugli interessi applicati al finanziamento, consentendo alle imprese di ridurre il costo complessivo dell'investimento.",
        ],
      },
      {
        title: "Chi può accedere all'agevolazione",
        paragraphs: [
          "L'agevolazione è rivolta principalmente alle micro, piccole e medie imprese operanti in diversi settori economici.",
          "Per accedere al beneficio è necessario che l'investimento rispetti i requisiti previsti dalla normativa e che sia collegato ad attività produttive e aziendali coerenti con gli obiettivi dell'impresa.",
        ],
      },
      {
        title: "Investimenti finanziabili",
        intro: "Gli investimenti ammessi sono:",
        list: [
          "Macchinari industriali",
          "Impianti produttivi",
          "Attrezzature aziendali",
          "Hardware e software",
          "Tecnologie digitali e investimenti orientati all'Industria 4.0",
        ],
      },
      {
        title: "Aspetti strategici da considerare",
        paragraphs: [
          "La gestione delle tempistiche rappresenta un elemento strategico nella pianificazione dell'investimento.",
          "L'accesso alla Nuova Sabatini richiede che la domanda venga presentata prima dell'acquisto dei beni oggetto dell'agevolazione.",
          "Pianificare correttamente tempi, forniture e modalità di acquisto consente di ridurre errori procedurali e di ottimizzare l'utilizzo dello strumento agevolativo.",
        ],
      },
    ],
    cta: "Vuoi valutare se la Nuova Sabatini è adatta alla tua azienda? Contattaci per una consulenza gratuita.",
  },
  {
    id: 2,
    slug: "on-invitalia",
    category: "Bandi",
    date: "18 Maggio 2026",
    title: "ON – Oltre Nuove Imprese a Tasso Zero: incentivi per giovani e donne che vogliono fare impresa",
    excerpt:
      "Una misura pensata per sostenere la nascita e lo sviluppo di nuove iniziative imprenditoriali attraverso finanziamenti agevolati e contributi.",
    icon: FileText,
    cover: "/blog-on-invitalia.jpg",
    sections: [
      {
        title: "Cos'è ON – Oltre Nuove Imprese a Tasso Zero",
        paragraphs: [
          "ON – Oltre Nuove Imprese a Tasso Zero è un incentivo gestito da Invitalia pensato per supportare la creazione e lo sviluppo di nuove attività imprenditoriali.",
          "La misura prevede agevolazioni che possono includere finanziamenti a tasso agevolato e contributi a fondo perduto destinati a programmi di investimento aziendali.",
          "L'obiettivo è favorire l'avvio e la crescita di imprese guidate principalmente da giovani e donne, sostenendo investimenti legati allo sviluppo dell'attività.",
        ],
      },
      {
        title: "Chi può accedere all'agevolazione",
        paragraphs: [
          "La misura è destinata prevalentemente a imprese composte da giovani e donne, incluse startup costituite da non oltre 36 mesi e imprese avviate da non più di 60 mesi.",
          "Possono accedere all'incentivo anche persone fisiche che intendono avviare una nuova iniziativa imprenditoriale, con l'impegno di costituire la società in caso di ammissione alle agevolazioni.",
          "Le modalità di accesso e l'intensità delle agevolazioni possono variare in funzione dell'anzianità aziendale e della struttura del programma di investimento.",
        ],
      },
      {
        title: "Spese e investimenti ammissibili",
        intro: "Tra le spese ammissibili vi sono:",
        list: [
          "Macchinari e attrezzature",
          "Impianti produttivi",
          "Software e tecnologie",
          "Opere murarie funzionali all'attività (entro certi limiti)",
          "Spese collegate al capitale circolante",
          "Servizi collegati allo sviluppo del progetto imprenditoriale",
        ],
      },
      {
        title: "Aspetti strategici da considerare",
        paragraphs: [
          "Uno degli aspetti più importanti riguarda la pianificazione preventiva del progetto imprenditoriale.",
          "La predisposizione di un business plan realistico, sostenibile e coerente con gli obiettivi dell'impresa rappresenta un elemento centrale nella valutazione della domanda.",
          "Anche la gestione delle tempistiche e la corretta pianificazione degli investimenti possono incidere in modo significativo sulla struttura del progetto e sull'accesso all'agevolazione.",
        ],
      },
    ],
    cta: "Hai un'idea imprenditoriale e vuoi verificare se ON Invitalia fa al caso tuo? Contattaci per una consulenza gratuita.",
  },
  {
    id: 3,
    slug: "resto-al-sud",
    category: "Finanza Agevolata",
    date: "24 Maggio 2026",
    title: "Resto al Sud: incentivi per avviare un'attività nel Mezzogiorno",
    excerpt:
      "Una misura pensata per sostenere nuove iniziative imprenditoriali attraverso contributi a fondo perduto e finanziamenti agevolati.",
    icon: MapPinned,
    cover: "/blog-resto-al-sud.jpg",
    sections: [
      {
        title: "Cos'è Resto al Sud",
        paragraphs: [
          "Resto al Sud è un incentivo gestito da Invitalia pensato per sostenere la nascita e lo sviluppo di nuove attività imprenditoriali nelle regioni del Mezzogiorno.",
          "La misura prevede agevolazioni che combinano contributi a fondo perduto e finanziamenti agevolati destinati alla realizzazione di programmi di investimento e allo sviluppo dell'attività imprenditoriale.",
          "L'obiettivo è favorire la crescita economica e incentivare la creazione di nuove imprese sul territorio.",
        ],
      },
      {
        title: "Chi può accedere all'agevolazione",
        paragraphs: [
          "L'incentivo è rivolto principalmente a persone fisiche che intendono avviare una nuova attività imprenditoriale nelle regioni del Mezzogiorno.",
          "La misura consente la costituzione dell'impresa sia in forma individuale sia societaria, purché nel rispetto dei requisiti previsti dalla normativa.",
          "Possono accedere anche alcune imprese già costituite da poco tempo, in presenza delle condizioni previste.",
          "La sostenibilità del progetto, la coerenza del business plan e la corretta pianificazione degli investimenti sono elementi centrali nella valutazione.",
        ],
      },
      {
        title: "Spese e investimenti ammissibili",
        intro: "Tra le spese ammissibili vi sono:",
        list: [
          "Macchinari, impianti e attrezzature",
          "Software, tecnologie e servizi digitali",
          "Opere murarie funzionali al progetto",
          "Spese di gestione e capitale circolante collegati all'avvio: utenze, canoni, materiali di consumo e materie prime",
        ],
      },
      {
        title: "Aspetti strategici da considerare",
        paragraphs: [
          "Uno degli aspetti più importanti riguarda la pianificazione preventiva del progetto imprenditoriale.",
          "La predisposizione di un business plan realistico, sostenibile e coerente con gli obiettivi aziendali rappresenta un elemento centrale nella valutazione della domanda.",
        ],
      },
    ],
    cta: "Sei nel Mezzogiorno e vuoi avviare una nuova attività? Valutiamo insieme la tua situazione. contattaci per una consulenza gratuita.",
  },
  {
    id: 4,
    slug: "smart-start-italia",
    category: "Startup",
    date: "3 Giugno 2026",
    title: "Smart&Start Italia: incentivi per startup innovative e progetti ad alto contenuto tecnologico",
    excerpt:
      "Una misura pensata per sostenere la nascita e la crescita di startup innovative attraverso finanziamenti agevolati e programmi di sviluppo.",
    icon: Rocket,
    cover: "/blog-smart-start-italia.jpg",
    sections: [
      {
        title: "Cos'è Smart&Start Italia",
        paragraphs: [
          "Smart&Start Italia è un incentivo gestito da Invitalia pensato per supportare la nascita e lo sviluppo di startup innovative ad alto contenuto tecnologico.",
          "La misura sostiene programmi di investimento orientati all'innovazione, alla digitalizzazione e allo sviluppo di nuovi prodotti, servizi o modelli di business, attraverso finanziamenti agevolati.",
          "In presenza di determinati requisiti territoriali, una parte dell'agevolazione può essere riconosciuta anche come contributo a fondo perduto.",
        ],
      },
      {
        title: "Chi può accedere all'agevolazione",
        paragraphs: [
          "L'incentivo è rivolto principalmente a startup innovative già costituite e iscritte nell'apposita sezione speciale del Registro delle Imprese.",
          "Possono presentare domanda anche persone fisiche che intendono costituire una startup innovativa successivamente all'eventuale ammissione alle agevolazioni.",
          "La sostenibilità del progetto, il contenuto innovativo dell'iniziativa e la coerenza del business plan sono elementi centrali nella valutazione.",
        ],
      },
      {
        title: "Spese e investimenti ammissibili",
        intro: "Tra le spese ammissibili vi sono:",
        list: [
          "Macchinari, impianti e attrezzature",
          "Software, tecnologie e servizi digitali",
          "Sviluppo di piattaforme e soluzioni innovative",
          "Consulenze specialistiche e servizi funzionali al progetto",
          "Spese collegate alla gestione e allo sviluppo dell'attività",
        ],
      },
      {
        title: "Aspetti strategici da considerare",
        paragraphs: [
          "Uno degli aspetti più importanti riguarda la struttura del progetto e il reale contenuto innovativo.",
          "La predisposizione di un business plan credibile, sostenibile e coerente con il mercato di riferimento rappresenta un elemento centrale nella valutazione.",
          "La pianificazione delle tempistiche e degli investimenti incide in modo significativo sulla sostenibilità finanziaria nel medio-lungo periodo.",
        ],
      },
    ],
    cta: "Hai una startup innovativa e vuoi accedere a Smart&Start? Analizziamo insieme il tuo progetto, contattaci per una consulenza gratuita.",
  },
  {
    id: 5,
    slug: "zes-unica",
    category: "Agevolazioni",
    date: "10 Giugno 2026",
    title: "Credito ZES Unica: come funziona e quali investimenti possono accedere all'agevolazione",
    excerpt:
      "Un incentivo pensato per sostenere investimenti produttivi e programmi di sviluppo nelle regioni del Mezzogiorno.",
    icon: BookOpen,
    cover: "/blog-zes-unica.jpg",
    sections: [
      {
        title: "Cos'è il Credito ZES Unica",
        paragraphs: [
          "Il Credito ZES Unica rappresenta una delle principali agevolazioni dedicate alle imprese che investono nel Mezzogiorno.",
          "L'incentivo è stato introdotto per favorire nuovi programmi di sviluppo, ampliamenti produttivi e investimenti strategici nelle aree ricomprese nella Zona Economica Speciale Unica.",
        ],
      },
      {
        title: "Chi può accedere all'agevolazione",
        paragraphs: [
          "Possono accedere imprese di diverse dimensioni e settori economici, purché effettuino investimenti ammissibili all'interno delle aree previste dalla normativa.",
          "L'accesso richiede una corretta pianificazione dell'investimento, la verifica preventiva dei requisiti e un'attenta valutazione delle spese da includere nel progetto.",
        ],
      },
      {
        title: "Investimenti agevolabili",
        intro: "Gli investimenti ammessi sono:",
        list: [
          "Macchinari e impianti",
          "Attrezzature industriali",
          "Beni strumentali nuovi",
          "Investimenti funzionali all'ampliamento o alla realizzazione di strutture produttive",
        ],
        afterList:
          "In alcuni casi, determinate opere possono concorrere al progetto complessivo pur non generando direttamente il credito d'imposta.",
      },
      {
        title: "Aspetti strategici da valutare",
        paragraphs: [
          "Uno degli aspetti più importanti riguarda la corretta strutturazione dell'investimento.",
          "Molte imprese commettono errori nella classificazione delle spese o nella pianificazione temporale degli acquisti, rischiando di compromettere l'accesso al beneficio.",
          "Per questo motivo è fondamentale predisporre un progetto coerente, sostenibile e compatibile con gli obiettivi aziendali, valutando attentamente anche gli aspetti finanziari e documentali.",
        ],
      },
    ],
    cta: "La tua impresa è nel Mezzogiorno? Valutiamo insieme se puoi accedere al Credito ZES Unica, contattaci per una consulenza gratuita.",
  },
];

export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
